<template>
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header page_title="Maak je profiel compleet" :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'" />
    <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @submit.prevent="onSubmit" novalidate>
          <button type="submit" ref="submit" hidden>submit</button>
          <div class="step-question">
            <div class="title text-14 text-center">
              Vertel ons iets over je opleidingen
            </div>
            <div class="icon">
              <div class="svg">
                <svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path
                      d="m0 0h200v120h-200v-120zm73.334 26.833c-3.369 5.0477-5.3338 11.118-5.3338 17.649 0 17.543 14.178 31.765 31.668 31.765 17.49 0 31.668-14.222 31.668-31.765 0-6.609-2.0122-12.747-5.4557-17.83l-26.562 8.3479-25.985-8.1666zm-23.334-7.3334 49.319 15.5 49.319-15.5-49.319-15.5-49.319 15.5zm2 93.5h94.503c0-19.915-21.155-36.059-47.251-36.059-26.096 0-47.251 16.144-47.251 36.059z"
                      fill="#fff"
                      fill-rule="nonzero"
                    />
                    <path
                      d="m126.88 26.652c3.4434 5.0834 5.4557 11.221 5.4557 17.83 0 17.543-14.178 31.765-31.668 31.765-17.49 0-31.668-14.222-31.668-31.765 0-6.5306 1.9648-12.601 5.3338-17.649l-23.334-7.3334 49.319-15.5 49.319 15.5-22.757 7.1521z"
                      stroke="#625A55"
                      stroke-linejoin="round"
                      stroke-width="4.2"
                    />
                    <polygon
                      points="51 19.5 100.32 35 149.64 19.5 100.32 4"
                      stroke="#625A55"
                      stroke-linejoin="round"
                      stroke-width="4.116"
                    />
                    <g
                      transform="translate(92 42)"
                      fill="#625A55"
                      fill-rule="nonzero"
                    >
                      <circle cx="4" cy="4" r="4" />
                      <circle cx="26" cy="4" r="4" />
                    </g>
                    <path
                      transform="translate(104.68 61.841) rotate(-8) translate(-104.68 -61.841)"
                      d="m96.184 59.341c5.6667 5.2941 11.333 6.3841 17 3.2699"
                      stroke="#625A55"
                      stroke-linecap="round"
                      stroke-width="4"
                    />
                    <path
                      d="m148.64 28.104v18.617"
                      stroke="#625A55"
                      stroke-linecap="round"
                      stroke-width="4.116"
                    />
                    <path
                      d="m53 113c0-19.915 21.155-36.059 47.251-36.059 26.096 0 47.251 16.144 47.251 36.059h-94.503z"
                      stroke="#625A55"
                      stroke-width="4.116"
                    />
                  </g>
                </svg>
              </div>
              <div class="answers" :style="`height: ${answered}%;`"></div>
            </div>
            <div v-for="(arr, key1) in guide" v-bind:key="key1">
              <div
                :id="questions[q.url].id"
                v-for="q in arr"
                v-bind:key="q.url"
                v-show="current_step == q.url"
                v-bind:class="[current_step == q.url ? 'active-question' : '']"
              >
                <div class="question heading-20-500 text-center">
                  {{ questions[q.url].display }}
                </div>
                <div class="form">
                  <div v-if="elContains([1, 2, 3, 4, 5], q.url)">
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="YES"
                          v-bind:id="`yes-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`yes-` + questions[q.url].id"
                          >Ja</label
                        >
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="NO"
                          v-bind:id="`no-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`no-` + questions[q.url].id"
                          >Nee</label
                        >
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="STUDYING"
                          v-bind:id="`s-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`s-` + questions[q.url].id"
                          >Studerend</label
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      elContains(q.url, '_YES') &&
                        !elContains(q.url, '_YES_EXTRA')
                    "
                  >
                    <div class="form-group w-square-icon">
                      <select
                        class="custom-select"
                        v-model="
                          form.user_answers[questions[q.url].id]['answer']
                        "
                        v-bind:id="`year-` + questions[q.url].id"
                        required
                      >
                        <option value="">Selecteer een antwoord</option>
                        <option
                          v-for="year in years"
                          :value="year"
                          v-bind:key="
                            `year-` + questions[q.url].id + `year` + year
                          "
                          >{{ year }}</option
                        >
                      </select>
                      <div
                        class="icon-wrapper dropdown position-absolute align-self-center border-left"
                      >
                        <svg-icon icon="chevron_s" />
                      </div>
                    </div>
                  </div>
                  <div v-else-if="elContains(q.url, '_YES_EXTRA')">
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="YES"
                          v-bind:id="`yes-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`yes-` + questions[q.url].id"
                          >Ja</label
                        >
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="NO"
                          v-bind:id="`no-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`no-` + questions[q.url].id"
                          >Nee</label
                        >
                      </div>
                    </div>
                  </div>
                  <div v-else-if="elContains(q.url, 'STUDYING_A')">
                    <ul class="list-unstyled">
                      <li
                        v-for="item in answers[1]"
                        v-bind:key="questions[q.url].id + '-' + item.id"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `fulltime-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `fulltime-` + questions[q.url].id + `-` + item.id
                            "
                            >{{ item.answer }}</label
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="elContains(q.url, 'STUDYING_B')">
                    <ul class="list-unstyled" v-if="q.seen_academic_year">
                      <li
                        v-for="item in answers[2]"
                        v-bind:key="questions[q.url].id + '-' + item.id"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `acadyear-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `acadyear-` + questions[q.url].id + `-` + item.id
                            "
                            >{{ item.answer }}</label
                          >
                        </div>
                      </li>
                    </ul>
                    <ul class="list-unstyled" v-if="q.seen_academic_year == false">
                      <li v-for="item in answers[3]" v-bind:key="questions[q.url].id + '-' + item.id">
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `acadyear-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `acadyear-` + questions[q.url].id + `-` + item.id
                            "
                          >{{ item.answer }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div hidden>
          <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
        </div>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="next_step != 'SUBMIT'"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >
          Volgende
        </button>
        <button
          v-if="next_step == 'SUBMIT'"
          type="button"
          title="Opslaan"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          Opslaan
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg
                viewBox="0 0 104 114"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g transform="translate(3.000000, 2.000000)">
                    <path
                      fill="#FFCD00"
                      d="M75.8803538,22.6521459 C79.3237954,27.7355205 81.3360193,33.8730895 81.3360193,40.4820737 C81.3360193,58.0252364 67.1577685,72.2467796 49.6680097,72.2467796 C32.1782509,72.2467796 18,58.0252364 18,40.4820737 C18,33.9514473 19.9647919,27.8811239 23.3337923,22.8333985 L-7.10542736e-15,15.5 L49.3187135,0 L98.6374269,15.5 L75.8803538,22.6521459 Z"
                      stroke="#625A55"
                      stroke-width="4.2"
                      stroke-linejoin="round"
                    />
                    <polygon
                      stroke="#625A55"
                      stroke-width="4.116"
                      stroke-linejoin="round"
                      points="-7.10542736e-15 15.5 49.3187135 31 98.6374269 15.5 49.3187135 0"
                    />
                    <g
                      transform="translate(41.000000, 38.000000)"
                      fill="#625A55"
                      fill-rule="nonzero"
                    >
                      <circle cx="4" cy="4" r="4" />
                      <circle cx="26" cy="4" r="4" />
                    </g>
                    <path
                      d="M45.1844298,55.3411731 C50.8510965,60.6352907 56.5177632,61.7252561 62.1844298,58.6110692"
                      stroke="#625A55"
                      stroke-width="4"
                      stroke-linecap="round"
                      transform="translate(53.684430, 57.841173) rotate(-8.000000) translate(-53.684430, -57.841173) "
                    />
                    <path
                      d="M97.6409366,24.1040278 L97.6409366,42.7209504"
                      stroke="#625A55"
                      stroke-width="4.116"
                      stroke-linecap="round"
                    />
                    <path
                      d="M2,109 C2,89.0851016 23.1552001,72.9408867 49.251462,72.9408867 C75.3477239,72.9408867 96.502924,89.0851016 96.502924,109 L2,109 Z"
                      stroke="#625A55"
                      stroke-width="4.116"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="sd-title large text-white text-center mb-4">
              Top!
            </div>
            <div class="">
              Je opleidingen staan in je profiel. Nu ben je beter vindbaar voor onze opdrachtgevers.
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
              :to="{ name: 'verify' }"
              title="Ga verder"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
              replace
              >Ga verder</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
export default {
  components: {
    VStepper
  },
  data: function() {
    return {
      guide: {
        1: [
          { url: 1 },
          { url: "1_YES", option: "years" },
          { url: "1_YES_EXTRA", option: "yes/no" },
          { url: "1_STUDYING_A", option: "fulltime" },
          { url: "1_STUDYING_B", option: "academic_year", seen_academic_year: true }
        ],
        2: [
          { url: 2 },
          { url: "2_YES", option: "years" },
          { url: "2_STUDYING_A", option: "fulltime" },
          { url: "2_STUDYING_B", option: "academic_year", seen_academic_year: true }
        ],
        3: [
          { url: 3 },
          { url: "3_YES", option: "years" },
          { url: "3_STUDYING_A", option: "fulltime" },
          { url: "3_STUDYING_B", option: "academic_year", seen_academic_year: true }
        ],
        4: [
          { url: 4 },
          { url: "4_YES", option: "years" }
          // { url: "4_STUDYING_A", option: "fulltime" },
          // { url: "4_STUDYING_B", option: "academic_year" }
        ],
        5: [{ url: 5 }, { url: "5_YES", option: "years" }]
      },
      steps: 5,
      step: 1,
      answered: 0,
      done: null,
      user: "",
      experience: null,
      questions: {},
      questions_array: {},
      answers: {},
      answers_array: {},
      form: {
        user_answers: {}
      },
      current_year: new Date().getFullYear(),
      current_step: "1",
      next_step: null,
      submit: null,
      prevRoute: null,
      change_subs: false
    };
  },
  props: ["action"],
  async created() {
    // this.$options.old;
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      immediate: true,
      handler() {
        this.answered = Math.floor((this.step / this.steps) * 100);
      }
    },
    form: {
      immediate: true,
      handler: function() {
        localStorage.setItem("form-pending", JSON.stringify(true));
        this.computeNextStep();
      },
      deep: true
    },
    current_step: {
      immediate: true,
      handler: function() {
        if (this.elContains(["1", "2", "3", "4", "5"], this.current_step)) {
          this.step = this.current_step;
        }
      },
      deep: true
    }
  },
  updated: function() {
    this.$nextTick(function() {
      this.computeNextStep();
    });
  },
  computed: {
    years() {
      var ctr = this.current_year;
      const last = this.current_year - 49;
      var arr = [];
      while (ctr >= last) {
        arr.push(ctr);
        ctr--;
      }
      return arr;
    }
  },
  methods: {
    async fetchData() {
      await this.getQuestions();
      await this.getAnswers();
      await this.fillForm();
      localStorage.removeItem("form-pending");
    },
    elContains(str, target) {
      return str.includes(target);
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/education/";

      // assign questions
      for (var obj in this.guide) {
        promises.push(
          new Promise(resolve => {
            for (var arr in this.guide[obj]) {
              this.$http({
                method: "GET",
                url: q_url + this.guide[obj][arr].url
              }).then(
                result => {
                  var q_id = result.data.data[0].id;
                  var q_number = result.data.data[0].number;
                  this.$set(this.questions, q_number, {
                    id: result.data.data[0].id,
                    display: result.data.data[0].display
                  });
                  this.$set(this.questions_array, q_number, q_id);
                  resolve();
                },
                error => {
                  console.error(error);
                }
              );
            }
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/";
      var arr = {
        fulltime: 1,
        academic_year: 2,
        academic_year_accelerated: 3
      };
      var answerIds = {};

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey
            }).then(
              result => {
                this.$set(
                  this.answers,
                  arr[itemKey], // qnumber
                  result.data.data
                );

                Object.keys(this.questions_array).forEach(questionNumber => {
                  promises.push(
                    new Promise(resolve => {
                      var question_id = this.questions_array[questionNumber];
                      var v;
                      if (
                        this.elContains(questionNumber, "_STUDYING_A") &&
                        itemKey == "fulltime"
                      ) {
                        answerIds = {};
                        for (v in result.data.data) {
                          answerIds[result.data.data[v].id] = false;
                        }
                        if (answerIds) {
                          this.$set(this.answers_array, question_id, answerIds);
                        }
                      }
                      if (
                        this.elContains(questionNumber, "_STUDYING_B") &&
                        itemKey == "academic_year"
                      ) {
                        answerIds = {};
                        for (v in result.data.data) {
                          answerIds[result.data.data[v].id] = false;
                        }
                        this.$set(this.answers_array, question_id, answerIds);
                      }
                      resolve();
                    })
                  );
                });
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });

      return Promise.all(promises);
    },
    async fillForm() {
      let promises = [];
      Object.keys(this.questions_array).forEach(questionNumber => {
        promises.push(
          new Promise(resolve => {
            var question_id = this.questions_array[questionNumber];
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
            resolve();
          })
        );
      });

      return Promise.all(promises);
    },
    computeNextStep() {
      var $id = $(".active-question");
      var answer = null;
      if ($id.length) {
        $id = $id.attr("id");
        answer = this.form.user_answers[$id]["answer"];
      }

      // step 1
      if (this.elContains(this.current_step, "1")) {
        if (this.current_step == "1") {
          if (answer == "YES") {
            this.next_step = "1_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "1_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "2";
          }
        }
        if (this.current_step == "1_YES") {
          this.next_step = "1_YES_EXTRA";
        }
        if (this.current_step == "1_YES_EXTRA") {
          this.next_step = "2";
        }
        if (this.current_step == "1_STUDYING_A") {
          this.next_step = "1_STUDYING_B";
          //change options in academic years
          if (answer == "Versneld") {
            this.guide[1][4].seen_academic_year = false;
          } else {
            this.guide[1][4].seen_academic_year = true;
          }
        }
        if (this.current_step == "1_STUDYING_B") {
          this.next_step = "2";
        }
      }

      // step 2
      if (this.elContains(this.current_step, "2")) {
        if (this.current_step == "2") {
          if (answer == "YES") {
            this.next_step = "2_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "2_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "3";
          }
        }
        if (this.current_step == "2_YES") {
          this.next_step = "3";
        }
        if (this.current_step == "2_STUDYING_A") {
          this.next_step = "2_STUDYING_B";
          if (answer == "Versneld") {
            this.guide[2][3].seen_academic_year = false;
          } else {
            this.guide[2][3].seen_academic_year = true;
          }
        }
        if (this.current_step == "2_STUDYING_B") {
          this.next_step = "3";
        }
      }

      // step 3
      if (this.elContains(this.current_step, "3")) {
        if (this.current_step == "3") {
          if (answer == "YES") {
            this.next_step = "3_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "3_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "4";
          }
        }
        if (this.current_step == "3_YES") {
          this.next_step = "4";
        }
        if (this.current_step == "3_STUDYING_A") {
          this.next_step = "3_STUDYING_B";
          if (answer == "Versneld") {
            this.guide[3][3].seen_academic_year = false;
          } else {
            this.guide[3][3].seen_academic_year = true;
          }
        }
        if (this.current_step == "3_STUDYING_B") {
          this.next_step = "4";
        }
      }

      // step 4
      if (this.elContains(this.current_step, "4")) {
        if (this.current_step == "4") {
          if (answer == "YES") {
            this.next_step = "4_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "5";
            // this.next_step = "4_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "5";
          }
        }
        if (this.current_step == "4_YES") {
          this.next_step = "5";
        }
        // if (this.current_step == "4_STUDYING_A") {
        //   this.next_step = "4_STUDYING_B";
        // }
        // if (this.current_step == "4_STUDYING_B") {
        //   this.next_step = "5";
        // }
      }

      // step 5
      if (this.elContains(this.current_step, "5")) {
        if (this.current_step == "5") {
          if (answer == "YES") {
            this.next_step = "5_YES";
          }
          if (answer == "NO") {
            this.next_step = "SUBMIT";
          }
          if (answer == "STUDYING") {
            this.next_step = "SUBMIT";
          }
        }
        if (this.current_step == "5_YES") {
          this.next_step = "SUBMIT";
        }
      }
    },
    nextStep() {
      var next = this.validateForm();
      if (next) {
        if (this.next_step) {
          if (this.next_step == "SUBMIT") {
            this.submit = true;
          } else if (this.next_step) {
            this.current_step = this.next_step;
            this.next_step = null;
          }
        }
      }
    },
    validateForm() {
      var $checkradios = $('input[type="radio"]:visible');
      var $input = $('input[required="required"]:visible');
      var $checkboxes = $('input[type="checkbox"]:visible');
      var $select = $("select:visible");

      if ($checkradios.length) {
        var checkedRadios = $('input[type="radio"]:visible:checked').length;
        if (!checkedRadios) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }

      if ($input.length) {
        var emptyInputs = $('input[required="required"]:invalid').length;
        if (emptyInputs) {
          alert("Graag het formulier volledig invullen."); // Please fill up form.
          return false;
        }
      }
      if ($select.length) {
        var $id = $("select:visible")
          .closest(".active-question")
          .attr("id");
        var answer = this.form.user_answers[$id]["answer"];
        if (!answer) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }

      if ($checkboxes.length) {
        var checkedCheckboxes = $('input[type="checkbox"]:visible:checked')
          .length;
        if (!checkedCheckboxes) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }
      return true;
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async onSubmit() {
      var next = this.validateForm();
      if (next) {
        // continue
        await this.save();
        this.done = true;
        this.registerUser(
          JSON.parse(localStorage.getItem("user-register")),
          false
        );
        // redirect to verify
        // setTimeout(() => this.$router.replace({ name: "verify" }), 5000);
      }
    },
    async save() {
      return new Promise(resolve => {
        let formData = {
          user_answer: this.form["user_answers"]
        };
        localStorage.setItem("education", JSON.stringify(formData));
        localStorage.removeItem("form-pending");
        resolve();
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.specialPending(to, from, next);
  }
};
</script>

<style scoped>
.step-question .icon,
.step-question .icon .svg {
  height: 114px;
}
.step-question .icon {
  width: 104px;
}
.form {
  margin: 30px 0 0;
}
</style>
